import { Download } from "lucide-react";

import { apiDownloadFile } from "@/lib/api";

/** Esporta un thread (chat o email) in PDF (lettura) o JSON (analisi). */
export function ThreadExportButtons({
  slug,
  canale,
  threadId,
}: {
  slug: string;
  canale: "chat" | "email";
  threadId: string;
}) {
  const base = `/api/v1/admin/agenti/${slug}/conversazioni/${canale}/${threadId}/export`;
  const short = threadId.slice(0, 8);
  const btn =
    "inline-flex items-center gap-1.5 rounded-md border bg-card px-2.5 py-1.5 text-xs font-semibold text-slate-700 hover:bg-muted";
  return (
    <div className="flex gap-2">
      <button
        type="button"
        className={btn}
        onClick={() => apiDownloadFile(`${base}?format=pdf`, `thread-${short}.pdf`)}
      >
        <Download className="size-3.5" /> PDF
      </button>
      <button
        type="button"
        className={btn}
        onClick={() => apiDownloadFile(`${base}?format=json`, `thread-${short}.json`)}
      >
        <Download className="size-3.5" /> JSON
      </button>
    </div>
  );
}
